// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3sPF-","col":"styles_col__1TwXt"};